/* ============================================================
   pp-product-main.js
   Custom PDP logic for Pur-Plant
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     Helpers
  ---------------------------------------------------------- */

  /**
   * Format price in cents to display string.
   * Uses Shopify.formatMoney when available, otherwise manual format.
   * Output example: "12,50 \u20ac"  /  "\u20ac12,50"  -- we use \u20acXX,XX as specified.
   */
  function formatMoney(cents) {
    if (cents == null) return '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '\u20ac' + amount;
  }

  /** Shorthand querySelector / querySelectorAll scoped to a root. */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  /** Debounce utility. */
  function debounce(fn, ms) {
    var timer;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  /**
   * Calculate shipping delivery date range.
   * Rules:
   * - Before 18:00 Spanish time: ships today (24-48h delivery = 1-2 business days)
   * - After 18:00: ships next business day
   * - Friday after 18:00 or weekend: ships Monday (arrives Lunes-Martes)
   * - Friday before 18:00: ships Friday (arrives Lunes-Martes)
   * Weekends (Sat/Sun) are never delivery days.
   */
  function getShippingDate() {
    var now = new Date();
    // Convert to Spanish time (CET/CEST)
    var spanish = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
    var hour = spanish.getHours();
    var dow = spanish.getDay(); // 0=Sun, 1=Mon...5=Fri, 6=Sat

    // Parse holidays from theme setting (YYYY-MM-DD per line) → Set
    var holidaysRaw = (window.ppShippingHolidays || '');
    var holidays = new Set(
      holidaysRaw.split(/[\n,]/).map(function(s){ return s.trim(); }).filter(function(s){ return /^\d{4}-\d{2}-\d{2}$/.test(s); })
    );
    function dateKey(d) {
      var y = d.getFullYear(), m = d.getMonth()+1, day = d.getDate();
      return y + '-' + (m<10?'0':'') + m + '-' + (day<10?'0':'') + day;
    }
    function isBusinessDay(d) {
      if (d.getDay() === 0 || d.getDay() === 6) return false;
      if (holidays.has(dateKey(d))) return false;
      return true;
    }

    var shipDate = new Date(spanish);

    // Determine ship date (when order leaves warehouse)
    if (dow === 5) {
      // Friday (any time) → ships Friday, delivery Lunes-Martes
    } else if (dow === 0) {
      // Sunday → ships Monday
      shipDate.setDate(shipDate.getDate() + 1);
    } else if (dow === 6) {
      // Saturday → ships Monday
      shipDate.setDate(shipDate.getDate() + 2);
    } else if (hour >= 18) {
      // After 18:00 Mon-Thu → ships next business day
      shipDate.setDate(shipDate.getDate() + 1);
    }

    // Push shipDate past any holidays that fell on the calculated day
    while (!isBusinessDay(shipDate)) {
      shipDate.setDate(shipDate.getDate() + 1);
    }

    // Delivery = 1-2 business days after ship date (skip weekends + festivos)
    function addBusinessDays(from, n) {
      var d = new Date(from);
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        if (isBusinessDay(d)) added++;
      }
      return d;
    }

    var minDate = addBusinessDays(shipDate, 1);
    var maxDate = addBusinessDays(shipDate, 2);

    var days = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'];
    var months = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];

    // If same day, show just one date; if different, show range
    if (minDate.getDate() === maxDate.getDate() && minDate.getMonth() === maxDate.getMonth()) {
      return days[minDate.getDay()] + ' ' + minDate.getDate() + ' ' + months[minDate.getMonth()];
    }
    // Same month: "Martes 24 - Miércoles 25 Marzo"
    if (minDate.getMonth() === maxDate.getMonth()) {
      return days[minDate.getDay()] + ' ' + minDate.getDate() + ' - ' + days[maxDate.getDay()] + ' ' + maxDate.getDate() + ' ' + months[maxDate.getMonth()];
    }
    // Different months: "Lunes 31 Mar - Martes 1 Abr"
    return days[minDate.getDay()] + ' ' + minDate.getDate() + ' ' + months[minDate.getMonth()] + ' - ' + days[maxDate.getDay()] + ' ' + maxDate.getDate() + ' ' + months[maxDate.getMonth()];
  }

  // Unified shipping line: countdown + delivery date
  var shippingRetries = 0;
  (function initShippingFull() {
    var el = qs('[data-pp-shipping-full]');
    if (!el) {
      shippingRetries++;
      if (shippingRetries > 10) return; // give up after 5s
      setTimeout(initShippingFull, 500);
      return;
    }

    var deliveryDate = getShippingDate();

    function update() {
      var now = new Date();
      var spanish = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
      var dow = spanish.getDay();
      var hour = spanish.getHours();

      // Mon-Thu before 18:00 → show countdown
      if (dow >= 1 && dow <= 4 && hour < 18) {
        var target = new Date(spanish);
        target.setHours(18, 0, 0, 0);
        var diff = target - spanish;

        if (diff > 0) {
          var h = Math.floor(diff / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var s = Math.floor((diff % 60000) / 1000);
          var pad = function(n) { return n < 10 ? '0' + n : '' + n; };

          var parts = [];
          if (h > 0) parts.push(h + (h === 1 ? ' hora' : ' horas'));
          if (m > 0) parts.push(m + (m === 1 ? ' minuto' : ' minutos'));
          parts.push(s + (s === 1 ? ' segundo' : ' segundos'));
          el.innerHTML = 'Compra antes de <strong>' + parts.join(' ') + '</strong> y recíbelo el <strong>' + deliveryDate + '</strong>';
          return;
        }
      }

      // No countdown → just show delivery date
      el.innerHTML = 'Compra ahora y recíbelo el <strong>' + deliveryDate + '</strong>';
    }

    update();
    // Use requestAnimationFrame throttled to ~1s for performance
    var lastTick = 0;
    function tick(ts) {
      if (ts - lastTick >= 1000) {
        lastTick = ts;
        update();
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  /* ----------------------------------------------------------
     References (resolved once DOM is ready)
  ---------------------------------------------------------- */

  var pdp;                // .pp-pdp  (section root)
  var mainImages;         // .pp-pdp__main-images
  var thumbs;             // NodeList of .pp-pdp__thumb
  var dots;               // NodeList of .pp-pdp__dot  (mobile)
  var priceEl;            // .pp-pdp__price
  var comparePriceEl;     // .pp-pdp__compare-price
  var addToCartBtn;       // .pp-pdp__add-to-cart-btn
  var addToCartText;      // text span inside add-to-cart
  var qtyInput;           // .pp-pdp__qty-input

  function cacheDOM() {
    pdp            = qs('.pp-pdp');
    if (!pdp) return false;
    mainImages     = qs('.pp-pdp__main-images', pdp);
    thumbs         = qsa('.pp-pdp__thumb', pdp);
    dots           = qsa('.pp-pdp__dot', pdp);
    priceEl        = qs('.pp-pdp__price', pdp);
    comparePriceEl = qs('.pp-pdp__compare-price', pdp);
    addToCartBtn   = qs('.pp-pdp__add-to-cart-btn', pdp);
    addToCartText  = addToCartBtn ? qs('span', addToCartBtn) || addToCartBtn : null;
    // Texto del botón configurado en el editor ("Añadir"), para restaurarlo tras el ✓
    // o al cambiar de variante. Si la página carga en agotado, se usa "Añadir".
    if (addToCartBtn && !addToCartBtn.disabled && !addToCartBtn.dataset.ppLabel) {
      addToCartBtn.dataset.ppLabel = addToCartText.textContent.trim();
    }
    qtyInput       = qs('.pp-pdp__qty-input', pdp);
    return true;
  }

  /* ----------------------------------------------------------
     1. Variant Selection
  ---------------------------------------------------------- */

  function getVariants() {
    return window.ppProductVariants || [];
  }

  function findVariantBySelectedOptions() {
    var selected = {};
    qsa('.pp-pdp__variant-group', pdp).forEach(function (group) {
      var activeBtn = qs('.pp-pdp__variant-btn.is-active', group);
      if (activeBtn) {
        var optionIndex = group.dataset.optionIndex || group.dataset.optionPosition;
        selected[optionIndex] = activeBtn.dataset.value || activeBtn.textContent.trim();
      }
    });

    var variants = getVariants();
    return variants.find(function (v) {
      return Object.keys(selected).every(function (idx) {
        // options is a 0-based array; optionIndex may be 1-based from Liquid
        var i = parseInt(idx, 10);
        var optVal = v.options[i] || v.options[i - 1];
        return optVal === selected[idx];
      });
    }) || null;
  }

  function updatePrice(variant) {
    if (!priceEl || !variant) return;
    // Target inner elements — textContent on the wrapper would wipe children.
    var currentEl = priceEl.querySelector('[data-pp-current-price]');
    var compareEl = priceEl.querySelector('[data-pp-compare-price]');
    var saveBadge = priceEl.querySelector('[data-pp-save-badge]');
    if (currentEl) currentEl.textContent = formatMoney(variant.price);
    var hasSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compareEl) {
      if (hasSale) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
        compareEl.style.display = '';
        if (currentEl) currentEl.classList.add('pp-pdp__price-current--sale');
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
        compareEl.style.display = 'none';
        if (currentEl) currentEl.classList.remove('pp-pdp__price-current--sale');
      }
    }
    if (saveBadge) {
      if (hasSale) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        saveBadge.textContent = '-' + pct + '%';
        saveBadge.hidden = false;
        saveBadge.style.display = '';
      } else {
        saveBadge.hidden = true;
        saveBadge.style.display = 'none';
      }
    }
    // Total block (footer)
    var totalEl = document.querySelector('[data-pp-total-price]');
    if (totalEl) totalEl.textContent = formatMoney(variant.price);
    // Update add-to-cart button variant id so addToCart picks current variant
    if (addToCartBtn) addToCartBtn.dataset.variantId = String(variant.id);
  }

  function updateAddToCartButton(variant) {
    if (!addToCartBtn) return;
    var qtyWrap = document.querySelector('[data-pp-qty-wrap]');
    if (!variant) {
      addToCartBtn.disabled = true;
      if (addToCartText) addToCartText.textContent = 'No disponible';
      if (qtyWrap) qtyWrap.hidden = true;
      return;
    }
    if (!variant.available) {
      addToCartBtn.disabled = true;
      if (addToCartText) addToCartText.textContent = 'Agotado';
      if (qtyWrap) qtyWrap.hidden = true;
    } else {
      addToCartBtn.disabled = false;
      if (addToCartText) addToCartText.textContent = addToCartBtn.dataset.ppLabel || 'Añadir';
      if (qtyWrap) qtyWrap.hidden = false;
    }
  }

  function updateURL(variant) {
    if (!variant) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  function scrollGalleryToVariantImage(variant) {
    if (!variant || !variant.featured_image || !variant.featured_image.src || !mainImages) return;
    var src = variant.featured_image.src.replace(/https?:/, '');
    var images = qsa('img', mainImages);
    for (var i = 0; i < images.length; i++) {
      var imgSrc = (images[i].src || images[i].dataset.src || '').replace(/https?:/, '');
      if (imgSrc && src.indexOf(imgSrc.split('?')[0].split('&')[0]) > -1 ||
          imgSrc && imgSrc.indexOf(src.split('?')[0].split('&')[0]) > -1) {
        var target = images[i].closest('.pp-pdp__main-image') || images[i];
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        setActiveThumb(i);
        break;
      }
    }
  }

  function initVariantSelection() {
    if (!pdp) return;

    pdp.addEventListener('click', function (e) {
      var btn = e.target.closest('.pp-pdp__variant-btn');
      if (!btn) return;

      var group = btn.closest('.pp-pdp__variant-group');
      if (group) {
        qsa('.pp-pdp__variant-btn', group).forEach(function (b) {
          b.classList.remove('is-active');
        });
      }
      btn.classList.add('is-active');

      var variant = findVariantBySelectedOptions();
      updatePrice(variant);
      updateAddToCartButton(variant);
      updateURL(variant);
      scrollGalleryToVariantImage(variant);
    });
  }

  /* ----------------------------------------------------------
     2. Gallery Thumbnails
  ---------------------------------------------------------- */

  function setActiveThumb(index) {
    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === index);
    });
    // Also update dots for mobile
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === index);
    });
  }

  function scrollMainImageTo(index) {
    if (!mainImages) return;
    var targets = qsa('.pp-pdp__main-image', mainImages);
    if (targets[index]) {
      targets[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  function initThumbnails() {
    if (!pdp || !thumbs.length) return;

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        scrollMainImageTo(index);
        setActiveThumb(index);
      });
    });
  }

  function initThumbnailObserver() {
    if (!mainImages) return;
    var images = qsa('.pp-pdp__main-image', mainImages);
    if (!images.length) return;

    // Desktop: use viewport as root (page scroll reveals images)
    // Mobile: use mainImages as root (horizontal swipe)
    var isMobile = window.innerWidth < 750;
    var observerRoot = isMobile ? mainImages : null;
    var observerThreshold = isMobile ? 0.5 : 0.3;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = images.indexOf(entry.target);
          if (idx !== -1) {
            setActiveThumb(idx);
          }
        }
      });
    }, {
      root: observerRoot,
      threshold: observerThreshold,
      rootMargin: isMobile ? '0px' : '-20% 0px -20% 0px'
    });

    images.forEach(function (img) { observer.observe(img); });
  }

  /* ----------------------------------------------------------
     3. Gallery Mobile Swipe / Dots
  ---------------------------------------------------------- */

  function initMobileDots() {
    if (!mainImages) return;

    // Clicking a dot scrolls to the corresponding image
    if (pdp) {
      pdp.addEventListener('click', function (e) {
        var dot = e.target.closest('.pp-pdp__dot');
        if (!dot) return;
        var index = dots.indexOf(dot);
        if (index === -1) return;
        scrollMainImageTo(index);
        setActiveThumb(index);
      });
    }

    // On scroll, update active dot (handled by the IntersectionObserver above)
    // Additional scroll listener for mobile snap detection
    var onScroll = debounce(function () {
      if (window.innerWidth >= 750) return;
      var images = qsa('.pp-pdp__main-image', mainImages);
      if (!images.length) return;

      var containerRect = mainImages.getBoundingClientRect();
      var centerX = containerRect.left + containerRect.width / 2;
      var closest = 0;
      var closestDist = Infinity;

      images.forEach(function (img, i) {
        var rect = img.getBoundingClientRect();
        var dist = Math.abs(rect.left + rect.width / 2 - centerX);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });

      setActiveThumb(closest);
    }, 80);

    mainImages.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ----------------------------------------------------------
     4. Accordions (smooth height animation)
  ---------------------------------------------------------- */

  function initAccordions() {
    if (!pdp) return;

    var detailsEls = qsa('details.pp-pdp__accordion', pdp);
    if (!detailsEls.length) {
      detailsEls = qsa('details', pdp);
    }

    var singleOpen = pdp.dataset.accordionSingle !== undefined;

    detailsEls.forEach(function (details) {
      var summary = qs('summary', details);
      var content = summary ? summary.nextElementSibling : null;
      if (!summary || !content) return;

      var animation = null;
      var isClosing = false;
      var isExpanding = false;

      summary.addEventListener('click', function (e) {
        // Close siblings if single-open mode
        if (!details.open && singleOpen) {
          detailsEls.forEach(function (other) {
            if (other !== details && other.open) {
              other.open = false;
            }
          });
        }
      });

      function closeDetails(el) {
        var sum = qs('summary', el);
        if (!sum) { el.open = false; return; }
        var startH = el.offsetHeight + 'px';
        var endH = sum.offsetHeight + 'px';
        el.style.overflow = 'hidden';
        var anim = el.animate(
          { height: [startH, endH] },
          { duration: 250, easing: 'ease-out' }
        );
        anim.onfinish = function () {
          el.open = false;
          el.style.height = '';
          el.style.overflow = '';
        };
      }
    });
  }

  /* ----------------------------------------------------------
     5. AJAX Add to Cart
  ---------------------------------------------------------- */

  function getSelectedVariantId() {
    var variant = findVariantBySelectedOptions();
    if (variant) return variant.id;
    // Fallback: read from button data attribute or URL
    if (addToCartBtn && addToCartBtn.dataset.variantId) {
      return parseInt(addToCartBtn.dataset.variantId, 10);
    }
    var params = new URLSearchParams(window.location.search);
    return params.get('variant') ? parseInt(params.get('variant'), 10) : null;
  }

  function getQuantity() {
    if (qtyInput) {
      var val = parseInt(qtyInput.value, 10);
      return isNaN(val) || val < 1 ? 1 : val;
    }
    return 1;
  }

  function setButtonLoading(loading) {
    if (!addToCartBtn) return;
    if (loading) {
      addToCartBtn.classList.add('is-loading');
      addToCartBtn.disabled = true;
      if (addToCartText) addToCartText.textContent = 'Añadiendo...';
    } else {
      addToCartBtn.classList.remove('is-loading');
      addToCartBtn.disabled = false;
      // Si no lo sustituye el ✓ o un mensaje de error, se vuelve al texto normal
      if (addToCartText && addToCartText.textContent === 'Añadiendo...') {
        addToCartText.textContent = addToCartBtn.dataset.ppLabel || 'Añadir';
      }
    }
  }

  function showButtonSuccess() {
    if (!addToCartBtn) return;
    addToCartBtn.classList.add('is-success');
    if (addToCartText) addToCartText.textContent = '\u2713';
    setTimeout(function () {
      addToCartBtn.classList.remove('is-success');
      var variant = findVariantBySelectedOptions();
      updateAddToCartButton(variant);
    }, 1500);
  }

  function showButtonError(message) {
    if (!addToCartBtn) return;
    addToCartBtn.classList.add('is-error');
    if (addToCartText) addToCartText.textContent = message || 'Error';
    setTimeout(function () {
      addToCartBtn.classList.remove('is-error');
      var variant = findVariantBySelectedOptions();
      updateAddToCartButton(variant);
    }, 2000);
  }

  function refreshCartDrawer() {
    // The pp-cart-drawer snippet is rendered inside the pp-header section.
    // Find the section ID from the header element in the DOM.
    var headerEl = qs('[data-section-id]', qs('.pp-header') || document);
    var sectionId = headerEl ? headerEl.dataset.sectionId : 'pp-header';

    return fetch(window.location.pathname + '?sections=' + sectionId, {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    })
    .then(function (res) { return res.json(); })
    .then(function (sections) {
      var html = sections[sectionId];
      if (!html) return;

      var tmp = document.createElement('div');
      tmp.innerHTML = html;

      // Update the cart drawer inner contents (keyed hydration target)
      var newInner = qs('[data-hydration-key="pp-cart-drawer-inner"]', tmp);
      var oldInner = qs('[data-hydration-key="pp-cart-drawer-inner"]');
      if (newInner && oldInner) {
        oldInner.innerHTML = newInner.innerHTML;
      }

      // Update cart count badges from the refreshed header
      var newBadges = qsa('.pp-header__cart-count, [data-cart-count]', tmp);
      var oldBadges = qsa('.pp-header__cart-count, [data-cart-count]');
      if (newBadges.length && oldBadges.length) {
        oldBadges.forEach(function (badge, i) {
          if (newBadges[i]) {
            badge.textContent = newBadges[i].textContent;
          }
        });
      }
    })
    .catch(function (err) {
      console.warn('[pp-product-main] Failed to refresh cart drawer:', err);
    });
  }

  function openCartDrawer() {
    // Primero el método del tema: guarda la posición de la página y la restaura al
    // cerrar el carrito (con showModal() a pelo, al cerrar saltaba arriba del todo)
    var drawer = qs('cart-drawer-component') || qs('.cart-drawer');
    var dialog = qs('cart-drawer-component dialog') || qs('.pp-cart-drawer__dialog');
    if (dialog && dialog.open) return;
    if (drawer && typeof drawer.showDialog === 'function') { try { drawer.showDialog(); return; } catch (e) {} }

    // Direct <dialog> open
    if (dialog && !dialog.open) {
      try { dialog.showModal(); return; } catch (e) { /* fallthrough */ }
    }

    // Component methods
    if (drawer) {
      if (typeof drawer.showDialog === 'function') { try { drawer.showDialog(); return; } catch (e) {} }
      if (typeof drawer.open === 'function')       { try { drawer.open();       return; } catch (e) {} }
      if (typeof drawer.show === 'function')       { try { drawer.show();       return; } catch (e) {} }
    }

    // details/summary pattern
    var details = qs('details#cart-drawer, details.cart-drawer');
    if (details) { details.open = true; return; }

    // Dispatch custom event for theme listeners
    document.dispatchEvent(new CustomEvent('cart:open'));

    // Click cart icon as last resort
    var cartIcon = qs('[data-cart-toggle], [data-cart-drawer-trigger], .header__icon--cart, .cart-icon-bubble');
    if (cartIcon) cartIcon.click();
  }

  function addToCart(variantId, quantity) {
    setButtonLoading(true);

    // PP: clamp qty to 1 for <1€ products when setting enabled
    if (window.ppLimitUnder1) {
      var variant = (window.ppProductVariants || []).find(function (v) { return v.id === variantId; });
      if (variant && variant.price < 100) quantity = 1;
    }

    // Find the section ID so /cart/add.js returns freshly rendered HTML
    var headerEl = qs('[data-section-id]', qs('.pp-header') || document);
    var sectionId = headerEl ? headerEl.dataset.sectionId : '';

    var payload = {
      id: variantId,
      quantity: quantity
    };
    // Suscripción (Loop): el widget de Loop escribe el plan elegido en un
    // <input name="selling_plan"> dentro del form; si no lo enviamos, el
    // producto entra al carrito como compra única. Vacío = compra única.
    var planInput = qs('#pp-product-form [name="selling_plan"]') || qs('.pp-pdp [name="selling_plan"]');
    if (planInput && planInput.value) {
      payload.selling_plan = planInput.value;
    }
    if (sectionId) {
      payload.sections = sectionId;
      payload.sections_url = window.location.pathname;
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (data) {
          throw new Error(data.description || data.message || 'Error adding to cart');
        });
      }
      return res.json();
    })
    .then(function (data) {
      // PP: post-add cart sanity — any <1€ line with qty>1 gets clamped to 1.
      // Covers race: user rapid-clicks ATC, /cart/add bumps qty each call.
      if (window.ppLimitUnder1) {
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var fixes = (cart.items || []).filter(function (it) {
              return it.price < 100 && it.quantity > 1;
            }).map(function (it) {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: it.key, quantity: 1 }),
              });
            });
            return Promise.all(fixes).then(function () { return data; });
          })
          .catch(function () { return data; });
      }
      return data;
    })
    .then(function (data) {
      setButtonLoading(false);
      showButtonSuccess();

      // 1. Open drawer immediately — don't wait on refresh
      openCartDrawer();

      // 2. Refresh content (async, non-blocking)
      if (typeof window.ppRefreshCartDrawer === 'function') {
        try {
          var p = window.ppRefreshCartDrawer({ open: true });
          if (p && typeof p.catch === 'function') {
            p.catch(function (err) { console.warn('[pp] refresh failed:', err); });
          }
        } catch (e) { console.warn('[pp] refresh threw:', e); }
      }

      // 3. Always dispatch cart:update for any other listener (count badges etc.)
      var evt = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data,
          sourceId: 'pp-product-main',
          data: {
            source: 'pp-product-main',
            sections: data.sections || {},
          },
        },
      });
      document.dispatchEvent(evt);

      // 4. Update cart count badges from /cart.js as backup
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var countEls = qsa('.pp-header__cart-count, [data-cart-count]');
          countEls.forEach(function (el) { el.textContent = cart.item_count; });
        })
        .catch(function () {});
    })
    .catch(function (err) {
      setButtonLoading(false);
      showButtonError(err.message || 'Error');
      console.error('[pp-product-main] Add to cart failed:', err);
    });
  }

  function initAddToCart() {
    // Delegate on document (not pdp) so handler works even if pdp lookup failed
    // or the DOM mutated after init. Guard with flag to prevent double-bind.
    if (window.__ppPdpAddToCartBound) return;
    window.__ppPdpAddToCartBound = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.pp-pdp__add-to-cart-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      if (btn.classList.contains('is-loading')) return;

      // Re-query refs in case init ran before DOM was ready
      if (!addToCartBtn) {
        addToCartBtn = btn;
        addToCartText = qs('span', btn) || btn;
      }

      var variantId = getSelectedVariantId();
      // Last-resort fallback: button's data attribute always holds current_variant.id
      if (!variantId && btn.dataset.variantId) {
        variantId = parseInt(btn.dataset.variantId, 10);
      }
      if (!variantId) {
        showButtonError('Selecciona una variante');
        return;
      }

      // Force-reset disabled state if out of sync
      if (btn.disabled && !btn.classList.contains('is-loading')) {
        btn.disabled = false;
      }

      var quantity = getQuantity();
      addToCart(variantId, quantity);
    }, true); // capture phase — runs before any other handler that might stop propagation
  }

  /* ----------------------------------------------------------
     6. Quantity Selector
  ---------------------------------------------------------- */

  function getMaxQty() {
    var wrap = document.querySelector('[data-pp-max-qty]');
    if (wrap) {
      var cap = parseInt(wrap.getAttribute('data-pp-max-qty'), 10);
      if (!isNaN(cap) && cap > 0) return cap;
    }
    return 99;
  }

  function updateQuantity(delta) {
    if (!qtyInput) return;
    var current = parseInt(qtyInput.value, 10);
    if (isNaN(current)) current = 1;
    var next = Math.min(getMaxQty(), Math.max(1, current + delta));
    qtyInput.value = next;

    // Dispatch input event in case anything listens
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ----------------------------------------------------------
     5b. Routine card ATC ("+" button on cross-sell items)
     Delegado a document — independiente del handler de
     pp-product-card-standalone (que solo se carga si las
     secciones MEJOR CON / EXPLORA renderizan productos).
  ---------------------------------------------------------- */

  function initRoutineAddToCart() {
    if (window.__ppRoutineAtcBound) return;
    window.__ppRoutineAtcBound = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.pp-pdp__routine-add[data-pp-add-to-cart]');
      if (!btn || btn.classList.contains('is-loading')) return;
      e.preventDefault();
      e.stopPropagation();

      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;

      var original = btn.textContent;
      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || 'add failed'); });
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = '✓';
        if (typeof window.ppRefreshCartDrawer === 'function') {
          try { window.ppRefreshCartDrawer({ open: true }); } catch (e) {}
        }
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            document.querySelectorAll('.pp-header__cart-count, [data-cart-count]').forEach(function (el) {
              el.textContent = c.item_count;
            });
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { sourceId: 'pp-pdp-routine' } }));
          })
          .catch(function () {});
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.textContent = '!';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
        console.error('[pp-pdp routine] add failed:', err);
      });
    }, true);
  }

  function initQuantitySelector() {
    if (!pdp) return;

    pdp.addEventListener('click', function (e) {
      if (e.target.closest('.pp-pdp__qty-minus')) {
        e.preventDefault();
        updateQuantity(-1);
        return;
      }
      if (e.target.closest('.pp-pdp__qty-plus')) {
        e.preventDefault();
        updateQuantity(1);
        return;
      }
    });

    // Sanitise manual input
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var val = parseInt(qtyInput.value, 10);
        var max = getMaxQty();
        if (isNaN(val) || val < 1) qtyInput.value = 1;
        else if (val > max) qtyInput.value = max;
      });
    }
  }

  /* ----------------------------------------------------------
     Init
  ---------------------------------------------------------- */

  function init() {
    if (!cacheDOM()) {
      console.log('[PP PDP] cacheDOM failed — .pp-pdp not found');
      return;
    }

    console.log('[PP PDP] Init: thumbs=' + thumbs.length + ', mainImages=' + (mainImages ? 'yes' : 'no'));

    try {
      initVariantSelection();
      initThumbnails();
      initThumbnailObserver();
      initMobileDots();
      initAccordions();
      initAddToCart();
      initRoutineAddToCart();
      initQuantitySelector();

      // Set initial active thumb
      if (thumbs.length) setActiveThumb(0);
    } catch (err) {
      console.error('[PP PDP] Init error:', err);
    }

    // Thumbnails are now CSS sticky — no JS positioning needed

    // Image zoom lightbox
    if (mainImages) {
      mainImages.addEventListener('click', function(e) {
        var img = e.target.closest('img');
        if (!img) return;

        var overlay = document.createElement('div');
        overlay.className = 'pp-pdp__zoom-overlay';
        var zoomImg = document.createElement('img');
        zoomImg.src = img.src.replace(/&width=\d+/, '&width=2400');
        zoomImg.className = 'pp-pdp__zoom-img';
        overlay.appendChild(zoomImg);

        var closeBtn = document.createElement('button');
        closeBtn.className = 'pp-pdp__zoom-close';
        closeBtn.innerHTML = '×';
        closeBtn.type = 'button';
        overlay.appendChild(closeBtn);

        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';

        requestAnimationFrame(function() { overlay.classList.add('is-open'); });

        function close() {
          overlay.classList.remove('is-open');
          setTimeout(function() {
            overlay.remove();
            document.body.style.overflow = '';
          }, 200);
        }

        closeBtn.addEventListener('click', close);
        overlay.addEventListener('click', function(ev) {
          if (ev.target === overlay) close();
        });
        document.addEventListener('keydown', function handler(ev) {
          if (ev.key === 'Escape') { close(); document.removeEventListener('keydown', handler); }
        });
      });
    }
  }

  // Run when DOM is ready

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
